import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { Post } from "../../../types/store";
import PostCard from "../../../components/PostCard";
import { fetchSavedPostsThunk } from "../../../store/features/posts/postsSlice";
import classes from "./styles.module.scss";
import { showNotification } from "../../../store/features/notifications/notificationSlice";

export const SavedPostsPage = () => {
  const dispatch = useAppDispatch();
  const { savedPosts, loading, error } = useAppSelector((state: any) => state.posts);

  useEffect(() => {
    dispatch(fetchSavedPostsThunk())
      .unwrap().then(() => {
        dispatch(showNotification({ message: "Saved posts loaded!", type: "success" }));
      })
      .catch(() => {
        dispatch(showNotification({ message: "Failed to load saved posts.", type: "error" }));
      });
  }, []);
  

  return (
    <div className={classes.SavedPostsPage}>
      <div className={classes.contentWrapper}>
        <div className={classes.infoWrapper}>
          <h2>Your Saved Posts</h2>
          <div className={classes.infoText}>
            <p>For you to use at any time</p>
          </div>
        </div>
        <div className={classes.results}>
          {loading && Array.from({ length: savedPosts.length }).map((_, i) => (
            <div key={i} className={classes.skeletonLoader}></div>
          ))}
          {savedPosts.map((post: Post) => (
            <PostCard
              isOnDash={true}
              key={post.post_id}
              post_id={post.post_id}
              text={post.caption}
              hashtags={post.hashtags}
              image={post.image_url}
            />
          ))}
        </div>
      </div>
    </div>
  );
}

export default SavedPostsPage;
